import React from 'react'
import { func, object, array, bool } from 'prop-types'
import {
  EmptyWidget,
  Footnote,
  Link,
  Icon,
  Color
} from '@cobalt/cobalt-react-components'
import {
  SETUP_MFA_SELECTOR_TITLE,
  SETUP_MFA_SELECTOR_MESSAGE,
  SETUP_MFA_SELECTOR_FOOTNOTE,
  SETUP_ALL_MFA_ALREADY_REGISTERED_ERROR
} from '../../constants/ui.labels'
import { LEARN_MORE_ABOUT_2FA } from '../../constants/links'
import { MFATypes } from '../../constants/mfa'
import { ContentHeader } from '../../components'
import SetupMFACard from './SetupMFACard'
import PageFlow from '../../components/PageFlow'
import RecoveryOTPConfiguration from '../../components/RecoveryOTPConfiguration'

const RECOVERY_CODES_STEP = 'RECOVERY_CODES_STEP'
const MFA_SELECTOR_STEP = 'MFA_SELECTOR_STEP'
const GO_BACK_ACTION = 'POP'

class SetupMFA extends React.PureComponent {
  static propTypes = {
    onSetupWebAuthn: func.isRequired,
    onSetupTOTP: func.isRequired,
    location: object.isRequired,
    history: object.isRequired,
    enabledMFAMechanisms: array.isRequired,
    hasAllMFAEnabled: bool.isRequired
  }

  state = {
    step: RECOVERY_CODES_STEP
  }

  getCurrentStep = () => {
    const {
      history: { action }
    } = this.props
    return action === GO_BACK_ACTION ? MFA_SELECTOR_STEP : this.state.step
  }

  handleRecoveryCodesConfirm = () => this.setState({ step: MFA_SELECTOR_STEP })

  hasMfaConfigured = mfa => this.props.enabledMFAMechanisms.includes(mfa)

  renderEmptyMfaSelector = () => (
    <React.Fragment>
      <EmptyWidget
        title={SETUP_MFA_SELECTOR_TITLE}
        message={SETUP_ALL_MFA_ALREADY_REGISTERED_ERROR}
        type={'info'}
      >
        <Icon name={Icon.CHECK_CIRCLE_OUTLINE} large color={Color.green[500]} />
      </EmptyWidget>
    </React.Fragment>
  )

  renderMfaSelector = () => (
    <React.Fragment>
      <ContentHeader
        title={SETUP_MFA_SELECTOR_TITLE}
        message={SETUP_MFA_SELECTOR_MESSAGE}
      />
      {!this.hasMfaConfigured(MFATypes.WEB_AUTHN) && (
        <SetupMFACard
          mfaType={MFATypes.WEB_AUTHN}
          onClick={this.props.onSetupWebAuthn}
        />
      )}
      {!this.hasMfaConfigured(MFATypes.TOTP) && (
        <SetupMFACard
          mfaType={MFATypes.TOTP}
          onClick={this.props.onSetupTOTP}
        />
      )}
      <Footnote halfTopSpace>
        <Link target="_blank" href={LEARN_MORE_ABOUT_2FA}>
          {SETUP_MFA_SELECTOR_FOOTNOTE}
        </Link>
      </Footnote>
    </React.Fragment>
  )

  render = () => {
    const { location: { state: { recoveryCodeList } } = [] } = this.props

    return (
      <PageFlow currentStep={this.getCurrentStep()}>
        <PageFlow.Step name={RECOVERY_CODES_STEP}>
          <RecoveryOTPConfiguration
            otpList={recoveryCodeList}
            onConfirm={this.handleRecoveryCodesConfirm}
          />
        </PageFlow.Step>
        <PageFlow.Step name={MFA_SELECTOR_STEP}>
          {this.props.hasAllMFAEnabled
            ? this.renderEmptyMfaSelector()
            : this.renderMfaSelector()}
        </PageFlow.Step>
      </PageFlow>
    )
  }
}

export default SetupMFA
